/**
 * Expiry date used for adding a card
 */

import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import TextInput from 'react-text-input';

import { cardSpecPropType } from 'prop-validators';
import { getFormattedExpirationDate } from './date-utils';
import { getCountryInfo } from '../utility/localizer'

const STYLES = {
	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	},
	dobWrapper: {
		margin: '10px 0 0'
	},
};
class DateOfBirth extends React.Component {
	constructor() {
		super();
		this.state = {
			showIsRequiredError: false,
			showIsInvalidError: false,
			inValidDate: false,
			lastCharacterIsSlash: false,
			dateOfBirth: ''
		};
	}

	/**
	 * Check for a date value
	 * If the field is required, we should show that this field needs a value
	 * @param {String} date - dateOfBirth
	 */
	handleCheckForValue(date) {
		let inValid = this.state.inValidDate
		this.setState({ showIsRequiredError: !date , showIsInvalidError: date && inValid});
	}

	/**
	 * Handle changing  dateofbirth
	 * @param {String} date - dateOfBirth date
	 * @return {String} date - the formatted date
	 */
	handleChange = (dob) => {

		let dateOfBirth = '';
		let flatDate = dob.replace(/\D+/g, '').slice(0, 8);
		const pattern = getCountryInfo(this.props.country).DOBPattern;

		let j = 0;
		for (let i = 0; i < flatDate.length; i++) {
			if (pattern[j] === '/') {
				dateOfBirth += '/';
				j++;
			}

			dateOfBirth += flatDate[i];
			j++;
		}

		this.setState({dateOfBirth: dateOfBirth})
		this.validateDateOfBirth(dateOfBirth)

		return dateOfBirth;
	}

	validateDateOfBirth(dateOfBirth) {

		const DOBPattern = getCountryInfo(this.props.country).DOBPattern;
		const dobDateCard = dateOfBirth.split('/');
		const patternsCard = DOBPattern.split('/');
		const yyyy = dobDateCard[patternsCard.indexOf('YYYY')];
		const currentYear = new Date().getFullYear().toString();

		if ((dateOfBirth.length === DOBPattern.length) && (currentYear > yyyy)) {
			this.setState({ inValidDate: false });
			this.props.handleChange(dateOfBirth)
		} else {
			this.setState({ inValidDate: true });
		}
	}


	/**
	 * Call parent's handleFocus
	 * @param {String} date - expiry date
	 */
	handleFocus = (date) => {
		this.props.handleFocus(date);
	}

	/**
	 * Check for a date value and call parent's handleBlur
	 * @param {String} date - dateOfBirth
	 */
	handleBlur = (date) => {
		this.handleCheckForValue(date);
		this.props.handleBlur(date);
	}

	render() {
		const expirySpecs = this.props.cardSpec.fields.expirationDate;
		let { errorMessage, showValidationErrors } = this.props;
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}
		return (
			<div className={classNames({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': !errorMessage && this.state.showIsRequiredError || this.state.showIsInvalidError
			})} style={{ margin: '10px 0 0', position: 'relative', textAlign: 'left' }}>
				{
					// <label style={{ 'marginBottom': 0, fontWeight: 'bold' }}>{this.props.label}</label>
				}
				<TextInput type="tel"
					id="dateofbirth"
					name="dateofbirth"
					className="vx_form-control vx_form-control_complex"
					label="Date of birth"
					autocomplete="off"
					helpText={this.props.pattern}
					handleChange={this.handleChange}
					handleFocus={this.handleFocus}
					handleBlur={this.handleBlur} />
				<div className={classNames({
					'vx_form-control-message': errorMessage
					})} style={{ ...STYLES.errorMessage, errorStyles }}>
					{errorMessage}
				</div>
			</div>
		);
	}
}

DateOfBirth.propTypes = {
	cardSpec: cardSpecPropType,
	label: PropTypes.string,
	helpText: PropTypes.string,
	errorMessage: PropTypes.string,
	handleChange: PropTypes.func,
	handleFocus: PropTypes.func,
	handleBlur: PropTypes.func,
	dir: PropTypes.string,
};

DateOfBirth.defaultProps = {
	handleFocus: () => {},
	handleBlur: () => {}
};

export default DateOfBirth;



// WEBPACK FOOTER //
// ./components/date-of-birth.js